import React from "react";
import Gpatable from "./Gpatable";
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableCaption,
    Stack,
    Box,
    Text
  } from '@chakra-ui/react'



export default function Grade(){
    return(
        <Box m="auto" maxW="1260px">
        <Stack direction={['column', 'row']} spacing='24px' maxW="1160px" m="auto">
                <Table variant='simple' mx="auto" size="sm">
        <TableCaption>Эдгээр үнэлгээнүүд голч бодоход нөлөөлдөггүй.</TableCaption>
        <Thead>
          <Tr>
            <Th>Үнэлгээ</Th>
            <Th>Тайлбар</Th>
          </Tr>
        </Thead>
        <Tbody>
        <Tr>
            <Td fontWeight="bold" textAlign="center">W</Td>
            <Td>Xэрэв суралцагч хичээлийг цаашид судлах боломжгүй эсвэл хангалтгүй судалсан бол улирлын шалгалтаас 7 хоногийн өмнө өөрийн саналаар уг тэмдэглэгээг багшид хүсэлт гаргаж хийлгэнэ. Суралцагч чөлөө авсан, хасагдсан, гарсан тохиолдолд дүгнэгдээгүй хичээлийн дүнг системээс тавина. Дараа нь тус хичээлийг шинээр үзэх хичээлийн адил бүртгүүлж судална.</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold" textAlign="center">R</Td>
            <Td>Тухайн хичээлийг амжилттай судалсан ч тодорхой шаардлагаар дахин судлах хүсэлт гаргасан бол оюутны өмнөх үнэлгээний үсгээр илтгэсэн дүнг R болгож, дахин судлах боломжоор хангана.</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold" textAlign="center">I</Td>
            <Td>Хүндэтгэн үзэх шалтгаанаар явцын үнэлгээ (реферат, даалгавар, дадлагын ажил дутуу, явцын шалгалтанд орж чадаагүй гэх мэт) дутуу боловч шалгалтын хугацаанд нөхөн гүйцэтгэж, шалгуулах нөхцөлтэйгээр хэрэглэнэ.</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold" textAlign="center">Е</Td>
            <Td>Хүндэтгэн үзэх шалтгаанаар улирлын шалгалтанд ороогүй бол багш (эсвэл салбар сургалтын албаны эрхлэгч) энэ тэмдэглэгээг бичнэ.</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold" textAlign="center">NC</Td>
            <Td>Багц цаг тооцохгүй бөгөөд уг хичээлийг оюутан судалсан гэсэн тэмдэглэгээ. Кредит тооцуулахгүйгээр хичээл судлах зөвшөөрөл авч амжилттай судалсан тохиолдолд тавигдах тэмдэглэгээ юм.</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold" textAlign="center">CR</Td>
            <Td>Өөр сургуулийн багц цагийг шилжүүлэн тооцох үед энэ тэмдэглэгээг хийх ба дипломын хавсралтан дээр энэ хэвээрээ бичигдэнэ.</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold" textAlign="center">NA</Td>
            <Td>Одоогоор дүгнэгдээгүй буюу судалж байгаа хичээлийн тэмдэглэгээ.</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold" textAlign="center">NR</Td>
            <Td>Багш эцсийн үнэлгээгээ үнэлгээ тавих хугацааны дотор тавьж, системд оруулаагүй тохиолдолд мэдээллийн системээс автоматаар тавьсан тэмдэглэгээ.</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold" textAlign="center">S</Td>
            <Td>"Тооцов" тэмдгэлгээ</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold" textAlign="center">U</Td>
            <Td>"Үл тооцов" тэмдгэлгээ</Td>
          </Tr>
        </Tbody>
        </Table>
        <Gpatable />
        </Stack>
        <Text textAlign="center" my="20" mx="5" fontSize="sm" opacity="0.5">(МУИС-ийн дүнгийн систем яаж явагддаг, юуг анхаарах тал дээр нийтлэл блог бичиж энд байрлуулах хүсэлтэй хүн байвал майл бичээрэй. <Text fontWeight="bold" display="inline">zagig35@gmail.com</Text>)</Text>
        </Box>
    )
}